import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { apiCallGetLegalContent, apiCallSaveLegalContent } from "../../../Core/Apicall";
import { toast } from "react-toastify";
import CommonShimmer from "../../Common/CommonShimmer/CommonShimmer";

const LegalContent: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"Terms" | "Privacy">("Terms");

  const [termsContent, setTermsContent] = useState<string>("");
  const [privacyContent, setPrivacyContent] = useState<string>("");
  const [loading, setLoading] = useState(false);



  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["blockquote"],
      ["link", "image"],
      [{ color: [] }, { background: [] }],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "blockquote",
    "link",
    "image",
    "color",
    "background",
  ];

  useEffect(() => {
    getLegalContent(activeTab);
  }, [activeTab]);

  const getLegalContent = async (type: "Terms" | "Privacy") => {
    try {
      setLoading(true);
      const res = await apiCallGetLegalContent({ type });
      if (res?.data?.content) {
        if (type === "Terms") {
          setTermsContent(res?.data?.content);
        } else {
          setPrivacyContent(res?.data?.content);
        }
      }
    } catch (error) {
      setLoading(false);
      console.log("Get Legal Content Error", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSave = async () => {
    try {

      const payload = {
        type: activeTab,
        content: activeTab === "Terms" ? termsContent : privacyContent,
      };
      await apiCallSaveLegalContent(payload)
      toast.success("Content saved successfully")
    } catch (error) {
      console.log("Save Legal Content Error", error);
    }
  };


  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <p style={styles.subtitle}>
            Update Terms & Conditions and Privacy Policy for the mobile app.
          </p>

          <button style={styles.saveBtn} onClick={handleSave}>
            Save Changes
          </button>
        </div>

        {/* Tabs */}
        <div style={styles.tabs}>
          <button
            style={{
              ...styles.tabBtn,
              ...(activeTab === "Terms" ? styles.activeTab : {}),
            }}
            onClick={() => setActiveTab("Terms")}
          >
            Terms & Conditions
          </button>

          <button
            style={{
              ...styles.tabBtn,
              ...(activeTab === "Privacy" ? styles.activeTab : {}),
            }}
            onClick={() => setActiveTab("Privacy")}
          >
            Privacy Policy
          </button>
        </div>

        <div style={styles.editor}>
          {loading ? (
            <CommonShimmer />
          ) : activeTab === "Terms" ? (
            <ReactQuill
              theme="snow"
              value={termsContent}
              onChange={setTermsContent}
              modules={modules}
              formats={formats}
            />
          ) : (
            <ReactQuill
              theme="snow"
              value={privacyContent}
              onChange={setPrivacyContent}
              modules={modules}
              formats={formats}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LegalContent;

const styles: any = {
  page: {
    padding: "30px",
  },

  card: {
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    padding: "25px",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },

  title: {
    margin: 0,
    fontSize: "22px",
    fontWeight: 600,
  },

  subtitle: {
    margin: "5px 0 0",
    color: "#494343",
    fontSize: "16px",
  },

  saveBtn: {
    background: "#4f46e5",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: 500,
  },

  tabs: {
    display: "flex",
    gap: "10px",
    marginBottom: "15px",
    borderBottom: "1px solid #eee",
    paddingBottom: "10px",
  },

  tabBtn: {
    padding: "6px 12px",
    borderRadius: "6px",
    border: "1px solid #ddd",
    background: "#f7f7f7",
    cursor: "pointer",
    fontWeight: 500,
  },

  activeTab: {
    background: "#4f46e5",
    color: "#fff",
    border: "1px solid #4f46e5",
  },

  editor: {
    marginTop: "10px",
  },
};